<div class="container-fluid p-0">
  <div class="mt-3 col-12">
    <p class="camera-info-label text-uppercase">Stadium Visiblity</p>
    <input inputFocus class="col-1" type="checkbox" id="hide_stadium" [(ngModel)]="competition.hide_stadium"
           [attr.placeholder]="'Is competition public'" (change)="onSelectChange($event)" [checked]="competition.hide_stadium" >
    <span class="col-11 camera-info-label">Hide stadium for this competition</span>
  </div>
    <app-camera-selector
        [cameras]="stadium?.pannellumStadiumCamera"
        [currentCamera]="currentCamera"
        (onSelectCamera)="currentCamera = $event">
    </app-camera-selector>
    <div class="row camera-info">
        <div class="col-lg-6 col-md-12 col-sm-12">
            <app-camera-info-editor
                [disabled]="!currentCamera"
                [type]="currentCamera?.createTooltipArgs?.type"
                [description]="currentCamera?.createTooltipArgs?.description"
                [posName]="currentCamera?.posName"
                [pitch]="currentCamera?.pitch"
                [yaw]="currentCamera?.yaw"
                (onEdit)="editCamera($event)">
            </app-camera-info-editor>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
            <app-stadium-background></app-stadium-background>
            <app-camera-documents-attacher
                [disabled]="!currentCamera"
                [documents]="currentCamera?.createTooltipArgs?.files"
                (attach)="attachDocument($event)"
                (delete)="deleteDocument($event)">
            </app-camera-documents-attacher>
        </div>
    </div>

    <app-stadium-camera-360
        #stadium360
        [lookingAtCamera]="currentCamera"
        [stadium]="stadium"
        [isAdmin]="true"
        (onDeleteCamera)="deleteCamera($event)"
        (onSelectCamera)="currentCamera = $event"
        (onUpdateCamera)="update()"
        *ngIf="stadium">
    </app-stadium-camera-360>
</div>
